/**
 * The small search glyph in an event card's top-right corner (2026-09-03):
 * opens the Nexus Dex with the event's Pokémon in the search box. Sized to
 * sit in a corner or on an existing row, never on a row of its own.
 */
import { Search } from "lucide-react";
import { useLocation } from "wouter";
import { eventDexSearchHref } from "@/lib/eventSearchLink";

export function EventSearchIcon({
  eventId,
  spawns,
  className,
  style,
}: {
  eventId: string;
  spawns: readonly { speciesId?: number | null }[] | undefined;
  className?: string;
  style?: React.CSSProperties;
}) {
  const [, setLocation] = useLocation();
  const href = eventDexSearchHref(spawns);
  if (!href) return null;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        setLocation(href);
      }}
      aria-label="Open these Pokémon in your Nexus Dex"
      title="Find these in your Nexus Dex"
      data-testid={`event-search-${eventId}`}
      className={`inline-flex items-center justify-center w-7 h-7 rounded-full shrink-0 ${className ?? ""}`}
      style={{
        background: "var(--surface-overlay)",
        border: "1px solid var(--border-subtle)",
        color: "var(--text-secondary)",
        ...style,
      }}
    >
      <Search className="w-3.5 h-3.5" aria-hidden />
    </button>
  );
}
